(function () {
  function initBadges() {
    document.querySelectorAll('.daily-sold-count').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10);
      var max = parseInt(el.dataset.max, 10);
      var productId = parseInt(el.dataset.productId || 0, 10);

      var today = new Date();
      var dateSeed =
        today.getFullYear() * 10000 +
        (today.getMonth() + 1) * 100 +
        today.getDate();
      var seed = dateSeed + productId;

      var rand = ((seed * 9301 + 49297) % 233280) / 233280;
      var num = Math.floor(rand * (max - min + 1)) + min;
      el.textContent = num;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBadges);
  } else {
    initBadges();
  }
})();
